// extracted by mini-css-extract-plugin
var _1 = "SeriesSelectValue-module__container--IuwMF";
var _2 = "SeriesSelectValue-module__icon--SxIiJ";
export { _1 as "container", _2 as "icon" }
